
import { useCallback, useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetPolygonByRegionId, GetPolygonByRegionIdResponse, IReturn } from "../../api/dtos/dtos";
import useGet from "../api/useGet";
import { JsonServiceClient } from "@servicestack/client";

const getData = (response?: SWRResponse<GetPolygonByRegionIdResponse, GetPolygonByRegionIdResponse>) => response?.data?.polygon;
const getError = (response?: SWRResponse<GetPolygonByRegionIdResponse, GetPolygonByRegionIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetPolygonByRegionIdResponse, GetPolygonByRegionIdResponse>) => ({});

const useGetPolygonByRegionId = (query?: Partial<GetPolygonByRegionId>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetPolygonByRegionId(query);
        }
    }, [query]);

    const fetcherFn: (client: JsonServiceClient, request: string | IReturn<GetPolygonByRegionIdResponse> | null) => Promise<GetPolygonByRegionIdResponse> | null = useCallback((client, request) => {
        client.headers.set("content-type", "application/json");

        if (!request) {
            return null;
        }

        return client.get(request);
    }, []);

    return useGet(request, { getData, getError, getAdditionalState }, configuration, fetcherFn);
}

export default useGetPolygonByRegionId;